<template>
  <div>
    <input id="keyword" placeholder="输入关键字选取地点" style="width: 300px" />
    <div id="container_jinfeishuju"></div>
  </div>
</template>
<script>
export default {
  props: {
    form: Object,
  },
  data() {
    return {
      addres: "",
      districtList: "",
      cityCode: "",
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    //  递归查询城市编码换算区域编码
    recursion(list, code) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].citycode == code) {
          this.cityCode = list[i].adcode;
          return;
        }
        if (list[i].districtList && list[i].districtList.length > 0) {
          this.recursion(list[i].districtList, code);
        }
      }
    },
    // 初始化加载地图
    initMap() {
      let that = this;
      const map = new T.Map("container_jinfeishuju", {
        projection: "EPSG:4326" // 使用经纬度坐标
      });
      this.map = map;
      map.centerAndZoom(new T.LngLat(120.21937542, 30.25924446), 13);

      // 初始化搜索服务
      this.initSearch(map);

      map.addEventListener("click", function (ev) {
        const lnglat = ev.lnglat;
        that.marker(lnglat.getLng(), lnglat.getLat(), map, false);
        that.getCode(lnglat.getLng(), lnglat.getLat(), false, "");
      });
      if (that.form.lng && that.form.lat) {
        that.addres = that.form.placeName;
        that.marker(that.form.lng, that.form.lat, map, true);
      }
    },

    initSearch(map) {
      let that = this;


      const localSearch = new T.LocalSearch(map, {
        pageCapacity: 10,
        onSearchComplete: function(results) {
          if (results) {
            // 通过getResults方法获取搜索结果
            const pois = results.getPois();
            if (pois && pois.length > 0) {
              that.showSearchResults(pois);
            }
          }
        }
      });

       // 输入框事件监听
      const keywordInput = document.getElementById('keyword');
      keywordInput.addEventListener('input', function(e) {
        const keyword = e.target.value;
        if (keyword.length > 1) {
          localSearch.search(keyword,1);
        }
      });
      keywordInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          const keyword = e.target.value;
          if (keyword) {
            localSearch.search(keyword,1);
          }
        }
      });
    },

    showSearchResults(pois) {
      let that = this;

      //移除旧的结果列表
      const oldList = document.getElementById('searchResultsList');
      if (oldList) {
        oldList.remove();
      }

      //创建结果列表容器
      const listContainer = document.createElement('div');
      listContainer.id = 'searchResultsList';
      listContainer.style.cssText = `
        position: absolute;
        z-index: 1000;
        background: white;
        border: 1px solid #ccc;
        max-height: 300px;
        overflow-y: auto;
        width: 300px;
        margin-left: 10px;
        margin-top: 5px;
        box-shadow: 0 2px 6px rgba(0,0,0,0.1);
      `;

      pois.forEach((poi, index) => {
        const item = document.createElement('div');
        item.style.cssText = `
          padding: 8px;
          cursor: pointer;
          border-bottom: 1px solid #eee;
          transition: background-color 0.2s;
        `;
        
        // 鼠标悬停效果
        item.addEventListener('mouseenter', function() {
          this.style.backgroundColor = '#f5f5f5';
        });
        item.addEventListener('mouseleave', function() {
          this.style.backgroundColor = 'white';
        });

        // 检查poi对象的结构，确保正确访问属性
        const poiName = poi.name;
        const poiAddress = poi.address;
        const poiLonLat = poi.lonlat;

        item.innerHTML = `
          <div style="font-weight: bold;">${poiName}</div>
          <div style="font-size: 12px; color: #666;">${poiAddress}</div>
        `;

        item.addEventListener('click', function() {
          if (!poiLonLat) {
            console.error('无法获取坐标信息');
            return;
          }
          
          console.log('原始坐标字符串:', poi.lonlat);
          let lng, lat;
          const coords = poi.lonlat.split(/[,\s]+/);

          if (coords.length >= 2) {
            lng = parseFloat(coords[0]);
            lat = parseFloat(coords[1]);
          }

          const isInvalidLng = isNaN(lng) || lng === '' || lng === null || lng === undefined;
          const isInvalidLat = isNaN(lat) || lat === '' || lat === null || lat === undefined;

          if (isInvalidLng || isInvalidLat) {
            console.error('坐标信息无效');
            return;
          }
          
          that.getCode(lng, lat, true, poiName);
          that.marker(lng, lat, that.map, true);
          
          // 更新输入框值
          document.getElementById('keyword').value = poiName;
          
          // 移除结果列表
          listContainer.remove();
        });

        listContainer.appendChild(item);

      });

      const keywordInput = document.getElementById('keyword');
      keywordInput.parentNode.appendChild(listContainer);
    },

    //逆地理编码
    getCode(lng, lat, type, name) {
      let that = this;

      const geocoder = new T.Geocoder();
      geocoder.getLocation(new T.LngLat(lng, lat), function(result) {
        if (!result) {
          console.error('逆地理编码返回null');
          return;
        }
        const status = result.getStatus();
        console.log('逆地理编码状态:', status, '消息:', result.getMsg());
        if (status !== 0) {
          console.warn('逆地理编码失败:', result.getMsg());
          return;
        }
        const address = result.getAddress();  // 获取详细地址
        const locationPoint = result.getLocationPoint();  // 获取坐标点
        const addressComponent = result.getAddressComponent();  // 获取地址组件
        
        // 发送坐标信息给父组件
        const lnglat = lng + "," + lat;
        that.$emit("MapObj", lnglat);
        
      });
    },

    marker(lng, lat, map, type) {
      map.clearOverLays();
      const marker = new T.Marker(new T.LngLat(lng, lat), {
        title: "当前位置",
        draggable: true // 设置为可拖动
      })
      marker.addEventListener('click', function() {
        // 可以添加标记点击后的处理
        console.log("123456")
      });

      marker.addEventListener('dragend', function(e) {
        const newLngLat = e.currentLnglat;
        that.getCode(newLngLat.getLng(), newLngLat.getLat(), false, "");
      });

      map.addOverLay(marker);

      if (type) {
        map.panTo(new T.LngLat(lng, lat));
      }

    },

    initMap_baidu() {
      let that = this;
      let map = new AMap.Map("container_jinfeishuju", {
        center: [120.21937542, 30.25924446],
        zoom: 13,
        resizeEnable: true,
      });
      //实时路况图层
      let trafficLayer = new AMap.TileLayer.Traffic({
        zIndex: 10,
      });
      // 将创建的点标记添加到已有的地图实例：
      map.add(trafficLayer); //添加图层到地图
      map.on("click", function (ev) {
        that.marker(ev.lnglat.lng, ev.lnglat.lat, map, false);
        that.getCode(ev.lnglat.lng, ev.lnglat.lat, false, "");
      });
      // 父组件传值解析地址 并回显
      if (that.form.lng && that.form.lat) {
        that.addres = that.form.placeName;
        that.marker(that.form.lng, that.form.lat, map, true);
      }
      // AMapUI.loadUI(["misc/PoiPicker"], function (PoiPicker) {
      //   var poiPicker = new PoiPicker({
      //     city: "杭州", //城市，默认全国
      //     input: "keyword", //使用联想输入的input的id
      //     extensions: "all",
      //   });
      //   //监听poi选中信息
      //   poiPicker.on("poiPicked", function (poiResult) {
      //     //用户选中的poi点信息
      //     debugger;
      //   });
      // });

      AMap.plugin(
        ["AMap.Autocomplete", "AMap.PlaceSearch", "AMap.DistrictSearch"],
        function () {
          let autoOptions = {
            city: "杭州", //城市，默认全国
            input: "keyword", //使用联想输入的input的id
            // extensions: "all",
          };
          let autocomplete = new AMap.Autocomplete(autoOptions);
          let placeSearch = new AMap.PlaceSearch({
            city: "杭州",
            // map: map,
          });
          //加载PoiPicker，loadUI的路径参数为模块名中 'ui/' 之后的部分
          AMap.event.addListener(autocomplete, "select", function (e) {
            //TODO 针对选中的poi实现自己的功能
            placeSearch.setCity(e.poi.adcode);
            placeSearch.search(e.poi.name);
            that.getCode(
              e.poi.location.lng,
              e.poi.location.lat,
              true,
              e.poi.name
            );
            //   that.$emit("MapObj", obj);
            that.marker(e.poi.location.lng, e.poi.location.lat, map, true);
          });
          // 获取城市编码和区域编码
          // let districtSearch = new AMap.DistrictSearch({
          //   // 关键字对应的行政区级别，country表示国家
          //   subdistrict: 2,
          //   level: "country", //查询行政级别为 市
          //   extensions: "all", // 基础信息base,all是返回信息
          // });
          // districtSearch.search("中国", function (status, result) {
          //   // 查询成功时，result即为对应的行政区信息
          //   that.districtList = result.districtList[0].districtList;
          // });
        }
      );
    },
    // 解析地址
    getCode_baidu(lng, lat, type, name) {
      let that = this;
      let district = null;
      AMap.plugin(["AMap.Geocoder", "AMap.DistrictSearch"], function () {
        // 引入 Geocoder 逆向地理编码插件，把经纬度转为地址
        const geocoder = new AMap.Geocoder({
          radius: 1000, // 以给定坐标为中心点，单位：米。取值范围：0-3000。默认值：1000
          extensions: "all", // 返回信息的详略。默认值：base，返回基本地址信息；取值为：all，返回地址信息及附近poi、道路、道路交叉口等信息
          batch: true,
        });
        const lnglat = lng + "," + lat;
        that.$emit("MapObj", lnglat);
        // geocoder.getAddress(lnglat, async (status, result) => {
        //   await that.recursion(
        //     that.districtList,
        //     result.regeocode.addressComponent.citycode
        //   );
        //   // 传入经纬度，根据给定坐标进行解析，把经纬度转为地址
        //   let obj = {
        //     placeName: type ? name : result.regeocode.pois[0].name,
        //     cityCode: that.cityCode,
        //     placeLon: lng,
        //     placeLat: lat,
        //   };
        //
        //   that.$emit("MapObj", obj);
        //   that.addres = type ? name : result.regeocode.pois[0].name;
        // });
      });
    },
    // 根据点击事件或者搜索事件生成坐标点
    marker_baidu(lat, lng, map, type) {
      let marker = new AMap.Marker({
        position: new AMap.LngLat(lat, lng), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title: "当前位置",
      });
      if (type) {
        map.setCenter([lat, lng]);
      }
      map.clearMap(); //清除所有遮罩物
      map.add(marker);
    },
  },
};
</script>
<style lang="less" scoped>
#container_jinfeishuju {
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 225px;
  margin-top: 15px;
}
#keyword {
  margin-left: 10px;
  border-radius: 4px;
  padding: 10px;
  border: 1px solid #5a5e66;
  z-index: 1000000000000000;
}
</style>
<style lang="less">
#pickerBox {
  position: absolute;
  z-index: 9999;
  top: -10px;
  width: 300px;
}

#pickerInput {
  width: 200px;
  padding: 5px 5px;
}

#poiInfo {
  background: #fff;
}

.amap_lib_placeSearch .poibox.highlight {
  background-color: #cae1ff;
}

.amap_lib_placeSearch .poi-more {
  display: none !important;
}

.amap-sug-result {
  z-index: 99999 !important;
}
</style>
